<template>
  <section id="pp-education" class="pp-section">
    <h2 class="pp-section__title">
      <i class="mdi mdi-school" aria-hidden="true"></i> Education
    </h2>

    <div v-if="hasEducation" class="pp-edu-grid">
      <div v-if="highestEducation" class="pp-edu-card pp-edu-card--primary">
        <p class="pp-edu-card__level">Highest qualification</p>
        <p class="pp-edu-card__title">{{ highestEducation.title }}</p>
        <p class="pp-edu-card__meta">
          <span v-if="highestEducation.university">{{ highestEducation.university }}</span>
          <span v-if="highestEducation.state"> · {{ highestEducation.state }}</span>
        </p>
        <p class="pp-edu-card__meta" v-if="highestEducation.year || highestEducation.marks">
          <span v-if="highestEducation.year">Class of {{ highestEducation.year }}</span>
          <span v-if="highestEducation.marks"> · {{ highestEducation.marks }}%</span>
          <span v-if="highestEducation.courseType"> · {{ highestEducation.courseType }}</span>
        </p>
      </div>

      <div
        v-for="(school, index) in schoolQualifications"
        :key="'school-' + index"
        class="pp-edu-card"
      >
        <p class="pp-edu-card__level">{{ school.level }}</p>
        <p class="pp-edu-card__title">{{ school.school }}</p>
        <p class="pp-edu-card__meta">
          <span v-if="school.board">{{ school.board }}</span>
          <span v-if="school.year"> · {{ school.year }}</span>
          <span v-if="school.marks"> · {{ school.marks }}%</span>
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PublicProfileEducation',
  props: {
    highestEducation: { type: Object, default: null },
    schoolQualifications: { type: Array, default: () => [] },
  },
  computed: {
    hasEducation() {
      return this.highestEducation || this.schoolQualifications.length;
    },
  },
};
</script>
